import {i18n} from '@online-offer/i18n';
import {Separator} from 'platform/components';
import {Heading, HStack, Icon, Link, Show, Space, Text, VStack} from 'platform/foundation';
import {formatPhoneNumber} from 'platform/locale';

import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {placeholderFallback} from '../../utils/placeholderFallback';
import {Chat} from '../Chat/Chat';

export function SellerCard() {
  const {owner, activeChatConversationId} = useGetOnlineOfferData();

  if (!owner) {
    return null;
  }

  const ownerName = [owner.firstName, owner.lastName].filter(Boolean).join(' ');

  return (
    <CardOo backgroundColor="semantic.bg.subtle">
      <VStack width="100%">
        <HStack width="100%" spacing={5}>
          {/* TODO: offer owner photo - not planned in online-offer v1 */}
          {/*<VStack width="100%" maxWidth={18}>*/}
          {/*  <AdaptiveImageDcNew ratio="1/1" fit="contain" url="./assets/images/person.png" />*/}
          {/*</VStack>*/}
          <VStack width="100%" spacing={2}>
            <VStack width="100%" spacing={1}>
              <Heading size={4}>{placeholderFallback(ownerName)}</Heading>
              <Text size="xSmall" color="secondary">
                {i18n.t('sellerCard.seller')}
              </Text>
            </VStack>
            <Separator spacing={0} />
            <Show when={owner.phoneNumber}>
              <HStack width="100%" spacing={2} align="center">
                <Icon size={5} value="social/telephone" />
                <Text size="xSmall">
                  {owner.phoneNumber &&
                    formatPhoneNumber(
                      `${owner.phoneNumber.prefix + owner.phoneNumber.number}`,
                      owner.phoneNumber.countryCode
                    )}
                </Text>
              </HStack>
            </Show>
            <HStack width="100%" spacing={2} align="center">
              <Icon size={5} value="social/email" />
              <Link size="xSmall" href={`mailto:${owner.email}`} title={owner.email} />
            </HStack>
          </VStack>
        </HStack>
        {/* TODO: offer owner phone number - not planned in online-offer v1 */}
        {/*<Show when={owner.phoneNumber}>*/}
        {/*  <Space vertical={5} />*/}
        {/*  <VStack maxWidth={[90, 90, '100%']} width="100%">*/}
        {/*    <Button*/}
        {/*      onClick={() => {*/}
        {/*        if (owner?.phoneNumber) {*/}
        {/*          window.open(`tel:${owner.phoneNumber.prefix + owner.phoneNumber.number}`);*/}
        {/*        }*/}
        {/*      }}*/}
        {/*      leftIcon="notification/phone"*/}
        {/*      leftIconSize={4}*/}
        {/*      title={i18n.t('sellerCard.callButton')}*/}
        {/*      data-testid="sellerCard-call"*/}
        {/*      variant="inverted"*/}
        {/*    />*/}
        {/*  </VStack>*/}
        {/*</Show>*/}
        {/* NOT YET */}
        <Show when={activeChatConversationId}>
          <Separator spacing={2} />
          <Space vertical={3} />
          <Chat conversationId={activeChatConversationId || ''} sellerName={ownerName} />
        </Show>
      </VStack>
    </CardOo>
  );
}
